import { normalizeEffectType } from '../../config/effectTypes';

/**
 * The focus view's connectors: one per step of the chain, drawn plainly — the
 * lanes and hops exist to survive a crowd, and there is no crowd here.
 *
 * A step in a loop's ring is its own edge and says its own type; the loop's
 * word belongs to the arc. Only a single-link focus (a cross-link) borrows the
 * selection's label. A cross-link is in `arrows` too, with the default word
 * ("johtaa"), so only a spine edge counts as the step's own edge.
 */
export function focusArrows(focusView, arrows, { focusLoop, focusLabel, focusColor, arrowPath }) {
  const out = [];
  for (let i = 1; i < focusView.ids.length; i += 1) {
    const from = focusView.ids[i - 1];
    const to = focusView.ids[i];
    const original = arrows.find((a) => a.from === from && a.to === to && !a.isGlobalLink);
    out.push({
      from,
      to,
      path: arrowPath(focusView.positions[from], focusView.positions[to]),
      strokeWidth: 2.5,
      label: original?.label ?? (focusLoop ? null : focusLabel),
      labelColor: original?.labelColor ?? focusColor,
      stroke: original?.stroke ?? focusColor,
      blockers: [],
      undirected: normalizeEffectType(original?.effectType) === 'is_same',
    });
  }
  return out;
}
